
import React, { Component, ErrorInfo, ReactNode } from 'react';
import { ShieldAlert, RefreshCw } from 'lucide-react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
    error: null
  };

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo);
  }

  private handleReset = () => {
    localStorage.removeItem('workspace_layout');
    localStorage.removeItem('workspace_configurations');
    window.location.reload();
  };

  public render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-[#1e2024] flex items-center justify-center p-6">
          <div className="max-w-md w-full bg-[#2a2d34] rounded-3xl p-8 border border-red-500/30 shadow-2xl text-center space-y-6">
            <div className="w-20 h-20 bg-red-500/10 rounded-full flex items-center justify-center mx-auto">
              <ShieldAlert size={40} className="text-red-500" />
            </div>
            <div className="space-y-2">
              <h1 className="text-xl font-black text-white uppercase tracking-widest">Error de Sistema</h1>
              <p className="text-gray-400 text-sm font-medium leading-relaxed">
                Se ha detectado una anomalía en la interfaz. Esto puede deberse a una configuración corrupta en el navegador.
              </p>
            </div>
            
            <div className="p-4 bg-black/20 rounded-2xl text-left overflow-hidden">
              <p className="text-[10px] font-mono text-red-400 break-all opacity-70">
                {this.state.error?.message}
              </p>
            </div>

            <button
              onClick={this.handleReset}
              className="w-full py-4 bg-blue-600 hover:bg-blue-700 text-white rounded-2xl font-black text-[11px] uppercase tracking-[0.2em] transition-all flex items-center justify-center gap-3 shadow-lg active:scale-95"
            >
              <RefreshCw size={18} />
              Reiniciar Interfaz
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
